
import { Message } from 'tplus-components-touch';

/**判断会员是否启用 */
import {IsMemberEnableProcessor} from '../../member/IsMemberEnableProcessor'


export class CheckUpdateMemberPasswordProcessorBlock
{
    static execute(memberDto)
    {
        if (!IsMemberEnableProcessor.execute(memberDto)) {
            Message.warn(`当前会员未启用，不能修改密码!`);
            return false;
        }
        if (!memberDto.MemberType.IsNeedPwd) {
            Message.warn(`此会员所属的会员类型不需要密码!`);
            return false;
        }
    }
}